import React, { useEffect, useRef, useState } from "react";
import { Spin } from "antd";
import { Button } from "primereact/button";
import { confirmPopup } from "primereact/confirmpopup";
import { Dialog } from "primereact/dialog";
import { ListBox } from "primereact/listbox";
import { Toast } from "primereact/toast";
import { getUsersByRoles } from "../../../apis/SettingApis";
import {
  assignQualityChecker,
  reAssignQualityChecker,
} from "../../../apis/ProjectApis";
import { Tag } from "primereact/tag";
import { USER_TYPE_QUALITY_CHECKER } from "../../../utils/constants";
import "./style.scss"

const AssigntoqualityCheckerDialog = (props) => {
  const [apiLoading, setApiLoading] = useState(false);
  const [allEligibleUsers, setAllEligibleUsers] = useState([]);
  const toast = useRef(null);

  const fetchUsers = () => {
    setApiLoading(true);
    getUsersByRoles(USER_TYPE_QUALITY_CHECKER, props.project?.id)
      .then((res) => {
        if (res.status === 200) {
          res.data.unshift({
            id: "",
            numProjectCanAssign: "Assignable Today"
          });
          setAllEligibleUsers(res.data);
          setApiLoading(false);
          console.log(JSON.stringify(res.data));
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  useEffect(() => {
    if (props.visible) {
      fetchUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.visible]);

  const assignToQualityChecker = (record) => {
    setApiLoading(true);
    let newValues = {
      projectId: props.project.id,
      userId: record.id,
    };
    assignQualityChecker(newValues)
      .then((res) => {
        if (res.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: `Project Assign To ${record.name} Successfully`,
            life: 3000,
          });
          setApiLoading(false);
          props.setVisible(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  const reAssignToQualityChecker = (record) => {
    setApiLoading(true);
    let newValues = {
      projectId: props.project.id,
      userId: record.id,
    };
    reAssignQualityChecker(newValues)
      .then((res) => {
        if (res.status === 200) {
          toast.current.show({
            severity: "success",
            summary: "Status",
            detail: `Project Assign To ${record.name} Successfully`,
            life: 3000,
          });
          setApiLoading(false);
          props.setVisible(false);
        } else {
          toast.current.show({
            severity: "error",
            summary: "Status",
            detail: res.response.data,
            life: 3000,
          });
          setApiLoading(false);
        }
      })
      .catch((e) => {
        toast.current.show({
          severity: "error",
          summary: "Status",
          detail: e,
          life: 3000,
        });
        setApiLoading(false);
      });
  };

  return (
    <React.Fragment>
      <div>
        <Toast ref={toast} />
        <Dialog
          header="Assign Quality Checker"
          visible={props.visible}
          onHide={() => props.setVisible(false)}
        >
          <Spin spinning={apiLoading}>
            <ListBox
              options={allEligibleUsers}
              listClassName="overflow-y-auto"
              listStyle={{ height: "50vh", whiteSpace: "nowrap", overflowX: "auto", width: "100%", display: "flex"  }}  // Prevent text wrapping              listStyle={{ height: "50vh" }}
              filter
              optionLabel={(e) => `${e.name} ${e.username}`}
              itemTemplate={(user) => {
                return (
                  <React.Fragment>
                    <div className="flex justify-content-between align-items-center">
                      <div style={{ width: "10rem"}}>
                        <h5 className="m-0 w-10rem">{user.name}</h5>
                      </div>
                      <div style={{ width: "3rem" }}>
                        <h5 className="m-0 w-10rem" style={{color: "red"}}>{user.level}</h5>
                      </div>
                      <div style={{ width: "18rem", textAlign: "center" }}>
                        <h5 className="m-0 w-10rem">{user.numProjectCanAssign}</h5>
                      </div>
                      {/* <div style={{ width: "16rem" }}>
                        {user.id != "" ? (<Tag
                          className="bg-gray-400"
                          severity="success"
                          value={
                            <h5 className="m-0 text-black-alpha-90">
                              {user.userType}
                            </h5>
                          }
                        />) : 
                          (<h5 className="m-0 text-black-alpha-90">
                            User Type
                          </h5>)}
                      </div> */}
                      <div style={{ width: "10rem" }}>
                        {user.id != "" ? (<Button
                          style={{ backgroundColor: "#037eea", zIndex: 9999 }}
                          label="Assign"
                          disabled={
                            props.project?.qualityChecker?.id === user.id ||
                              props.project?.employee?.id === user.id
                              ? true
                              : false
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            confirmPopup({
                              target: e.currentTarget,
                              message: "Are you sure you want to proceed?",
                              icon: "pi pi-exclamation-triangle",
                              accept: () =>
                                props?.project?.qualityChecker?.id
                                  ? reAssignToQualityChecker(user)
                                  : assignToQualityChecker(user),
                            });
                          }}
                        />) : ("")}
                      </div>
                    </div>
                  </React.Fragment>
                );
              }}
            />
          </Spin>
        </Dialog>
      </div>
    </React.Fragment>
  );
};

export default AssigntoqualityCheckerDialog;
